<div class="px-4 py-4 md:px-2 lg:px-4">
	<div class="p-fluid flex flex-column lg:flex-row">
		<ul class="list-none m-0 p-0 flex flex-row lg:flex-column justify-content-evenly md:justify-content-between lg:justify-content-start mb-5 lg:pr-6 lg:mb-0" *ngIf="!api.adminOrder">
			<li *ngFor="let m of menu; let i = index" (click)="activeMenu = i;">
				<a pRipple class="flex align-items-center cursor-pointer p-3 border-round text-800 hover:surface-hover transition-duration-150 transition-colors">
					<i class="pi {{m.icon}} md:mr-2"></i>
					<span class="font-medium hidden md:block white-space-nowrap">{{m.label}}</span>
				</a>
			</li>
		</ul>

		<form class="" #invoicingForm="ngForm" (ngSubmit)="saveAddress(invoicingForm)" *ngIf="activeMenu == 0 ">
			<div class="surface-card shadow-2 border-round flex-auto transition-all fadeinright w-full" >
				<div class="grid">
					<div class="col-12 p-4">
						<div class="text-900 font-semibold text-lg mt-3">Profil {{api.user.Name}}</div>
						<p-divider></p-divider>
					</div>
					<div class="col-6 pl-4 pr-3">
						<label for="email" class="block font-medium text-900 mb-2">Email de connexion</label>
						<input id="email" name="email" pInputText [(ngModel)]="api.user.email" type="text" [pKeyFilter]="'email'" [pValidateOnly]=>
					</div>
					<div class="col-6 pl-3 pr-4">
						<label class="block font-medium text-900 mb-2">Emails pour la newsletter</label>
						<input name="emailForNewsletter1" pInputText [(ngModel)]="api.user.emailForNewsletter1" type="email" [pKeyFilter]="'email'" >
						<input name="emailForNewsletter2" pInputText [(ngModel)]="api.user.emailForNewsletter2" type="email" [pKeyFilter]="'email'" >
						<input name="emailForNewsletter3" pInputText [(ngModel)]="api.user.emailForNewsletter3" type="email" [pKeyFilter]="'email'" >
					</div>
				</div>
				<div class="grid m-0 my-4">
					<div class="col-12 pl-4 pr-3">
						<div class="text-900 font-semibold text-lg mt-3">Adresse de facturation</div>
						<p-divider></p-divider>
						<!-- <app-address [address]=""></app-address> -->
						<div class="mb-4" *ngFor="let f of fields">
							<ng-container *ngIf="colInfos['MainInvoicing'+f] && columns['MainInvoicing'+f] && !dropdowns[f]">
								<label class="block font-medium text-900 mb-2">{{columns['MainInvoicing'+f]}} 
									<small style="float: right">{{customer['MainInvoicing'+f] != null ? customer['MainInvoicing'+f].length : 0}} / {{colInfos['MainInvoicing'+f].max}}</small>
								</label>
								<input name="{{'MainInvoicing'+f}}" *ngIf="colInfos['MainInvoicing'+f].type == 'nvarchar'" [maxlength]="colInfos['MainInvoicing'+f].max" [(ngModel)]="customer['MainInvoicing'+f]" type="text" pInputText [required]="required.indexOf(f) > -1">
							</ng-container>
							<p-dropdown *ngIf="dropdowns[f] && this[dropdowns[f].options]" [options]="this[dropdowns[f].options]" [(ngModel)]="customer['MainInvoicing'+f]" name="{{'MainInvoicing'+f}}" [required]="true"></p-dropdown>
						</div>
						<div class="text-right pb-2">
							<button type="submit" pButton pRipple label="Enregistrer" class="w-auto" [disabled]="!invoicingForm.dirty || invoicingForm.invalid"></button>
						</div>
					</div>
				</div>
			</div>
		</form>

		<div class="flex-auto transition-all fadeinright" *ngIf="activeMenu == 1">
			<div class="grid">
				<div class="col-6 pl-3 pr-4 ">
					<form class="surface-card p-5 shadow-2 border-round " #deliveryForm="ngForm" (ngSubmit)="saveAddress(deliveryForm)" >
						<div class="text-900 font-semibold text-lg mt-3">
							Adresse de livraison par défaut
						</div>
						<p-checkbox [trueValue]="1" [falseValue]="0" label="similaire à facturation" [binary]="true" name="UseInvoicingAddressAsDeliveryAddress" [(ngModel)]="customer.UseInvoicingAddressAsDeliveryAddress"></p-checkbox>    
						<p-divider></p-divider>
						<div class="mb-4" *ngFor="let f of fields">
							<ng-container *ngIf="colInfos['MainDelivery'+f] && columns['MainDelivery'+f] && !dropdowns[f]">
								<label class="block font-medium {{customer.UseInvoicingAddressAsDeliveryAddress == 1 ? 'text-300' : 'text-900'}} mb-2">		{{columns['MainDelivery'+f]}} 
									<small style="float: right">{{customer['MainDelivery'+f] != null ? customer['MainDelivery'+f].length : 0}} / {{colInfos['MainDelivery'+f].max}}</small>
								</label>
								<input  name="{{'MainDelivery'+f}}"  [disabled]="customer.UseInvoicingAddressAsDeliveryAddress == 1" *ngIf="colInfos['MainDelivery'+f].type == 'nvarchar'" [maxlength]="colInfos['MainDelivery'+f].max" [(ngModel)]="customer['MainDelivery'+f]" type="text" pInputText [required]="required.indexOf(f) > -1">
							</ng-container>
							<p-dropdown *ngIf="dropdowns[f] && this[dropdowns[f].options]" [options]="this[dropdowns[f].options]" [(ngModel)]="customer['MainDelivery'+f]" name="{{'MainDelivery'+f}}"></p-dropdown>

						</div>
						<div class="text-right pb-2">
							<button type="submit" pButton pRipple label="Enregistrer" class="w-auto" [disabled]="!deliveryForm.dirty || deliveryForm.invalid"></button>
						</div>
					</form>
				</div>
				<div class="col-6 p-2" *ngFor="let c of contacts; let i = index">
					<form #adressForm="ngForm" class="{{!c.Id ? 'surface-200' : 'surface-card'}} p-5 shadow-2 border-round " >
						<input type="hidden" name="Id" [(ngModel)]="c.Id" />
						<div class="text-900 font-semibold text-lg mt-3" *ngIf="c.Id">Adresse n°{{i+2}}</div>
						<div class="text-900 font-semibold text-lg mt-3" *ngIf="!c.Id">Saisissez une autre adresse</div>
						<p-divider></p-divider>
						<div class="mb-4" *ngFor="let f of fields">
							<ng-container *ngIf="colInfos[formatContactField(f)] && columns[formatContactField(f)] && !dropdowns[f]">
								<label class="block font-medium text-900 mb-2">{{columns[formatContactField(f)]}} 
									<small style="float: right">{{c[formatContactField(f)] != null ? c[formatContactField(f)].length : 0}} / {{colInfos[formatContactField(f)].max}}</small>
								</label>
								<input  name="{{formatContactField(f)}}" [(ngModel)]="c[formatContactField(f)]" type="text" pInputText [required]="required.indexOf(f) > -1">
							</ng-container>
							<p-dropdown *ngIf="dropdowns[f] && this[dropdowns[f].options]" [options]="this[dropdowns[f].options]" [(ngModel)]="c[formatContactField(f)]" name="{{formatContactField(f)}}"></p-dropdown>
						</div>

						<div class="text-right">
							<button *ngIf="c.Id"  pButton pRipple label="Supprimer" class="w-auto p-button-danger mr-2" (click)="deleteContact(c)"></button>
							<button (click)="saveContact(adressForm)" pButton pRipple label="{{c.Id ? 'Modifier' : 'Ajouter l\'adresse'}}" class="w-auto" [disabled]="!adressForm.dirty || adressForm.invalid"></button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<div class="surface-card p-5 shadow-2 border-round flex-auto transition-all fadeinright" *ngIf="activeMenu == 2">
			<div class="text-900 font-semibold text-lg mt-3">Modifier mon mot de passe</div>
			<p-divider></p-divider>
			<div class="flex gap-5 flex-column-reverse md:flex-row">
				<div class="flex-auto p-fluid">
					<div class="mb-4">
						<label for="password" class="block font-medium text-900 mb-2">Nouveau mot de passe</label>
						<p-password type="password" [toggleMask]="true" [(ngModel)]="newPass.password"></p-password>
					</div>

					<div class="mb-4">
						<label for="password2" class="block font-medium text-900 mb-2">Confirmer mon mot de passe</label>
						<p-password type="password" [toggleMask]="true" [(ngModel)]="newPass.password2"></p-password>
					</div>

					<div class="text-right">
						<small class="p-error" *ngIf="newPass.password != newPass.password2">Les mots de passe ne correspondent pas.</small><br/>
						<button [disabled]="newPass.password != newPass.password2 || newPass.password == ''" (click)="savePass()" pButton pRipple label="Enregistrer" class="w-auto"></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>